import React, { Component } from 'react';

class UnauthorizedPage extends Component {
	render() {
		return (
			// <Grid centered stackable className="with-padding">
			// 	<Grid.Row>
			// 		<Grid.Column>
			<div>Unauthorized</div>
			// 		</Grid.Column>
			// 	</Grid.Row>
			// </Grid>
		);
	}
}

export default UnauthorizedPage;
